"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Burden = void 0;
var Logger_1 = require("../core/Logger");
var logger = Logger_1.Logger.get('foundation/Burden');
exports.Burden = {
    /**
     * Resolves the specified burden by invoking the correct cleanup operation for the respective type.
     */
    resolve: function (burden) {
        toFunction(burden)();
    },
    /**
     * Resolves all the specified burdens by invoking the correct cleanup operation for the respective type.
     */
    resolveAll: function (burdens) {
        burdens.forEach(exports.Burden.resolve);
    }
};
var toFunction = function (burden) {
    if (burden instanceof Function) {
        return burden;
    }
    if ('cancel' in burden) {
        return function () { return burden.cancel(); };
    }
    if ('destroy' in burden) {
        return function () { return burden.destroy(); };
    }
    // Maybe throw?
    // tslint:disable-next-line: no-console
    return function () { return logger.warn('Burden resolved to nothing...'); };
};
